import "../../../../markdown/blog/superresolucion-inteligencia-artificial-zoom-infinito-imaginacion-infinita/Style.css";
import * as React from 'react';
export default {
  React
};